<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-fbaFlipOrderDashboard',
  components: { PageTable },
}
</script>
